import { CustomError } from 'core'

export class InvalidOriginForLoginError extends CustomError {}
export class NoOpenAccountError extends CustomError {}
